module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.2d9158b0.png";